module.exports = __webpack_public_path__ + "static/media/2-4.33a43a6b.png";